import classNames from "classnames";
import Tooltip from "components/utilities/Tooltip/Tooltip";
import Image from "next/legacy/image";
import React, { useState } from "react";
import classes from "./Bubble.module.scss";
import { PositionKey } from "./bubbleData";

interface Props extends Omit<React.ComponentPropsWithoutRef<"div">, "onClick"> {
  imageSrc?: string;
  name?: string;
  onClick?: (positionKey: PositionKey) => void;
  size: "big" | "small" | "medium";
  positionKey?: PositionKey;
  position?: string;
  disabled?: boolean;
  bio?: string;
  filter?: PositionKey | null;
}

const Bubble: React.FC<Props> = ({
  imageSrc,
  name,
  onClick,
  size,
  positionKey,
  position,
  disabled,
  bio,
  className,
  filter,
  ...htmlProps
}) => {
  const [isClicked, setIsClicked] = useState(false);

  const handlePhotoClick = () => {
    setIsClicked(false);
  };

  const handleFilteClick = () => {
    if (positionKey) {
      onClick?.(positionKey);
    }
  };

  if (!position) {
    return null;
  }

  return (
    <>
      <div
        {...htmlProps}
        className={classNames(
          classes[`bubble__item--${size}${disabled ? "--disabled" : ""}`]
        )}
        onClick={imageSrc ? handlePhotoClick : handleFilteClick}
        data-tooltip-id={`my-tooltip-${name}`}
      >
        {imageSrc ? (
          <div style={{ position: "relative", height: "100%" }}>
            <Image
              className={classNames(
                classes.bubble__itemImage,
                !!(isClicked || disabled) && classes.bubble__itemImageDisabled
              )}
              src={imageSrc}
              alt={name}
              layout="fill"
              objectFit="cover"
            />
          </div>
        ) : (
          <p className={classes.bubble__text}>{name}</p>
        )}
      </div>
      {position && (!filter || filter === positionKey) && (
        <Tooltip
          id={`my-tooltip-${name}`}
          message={bio || ""}
          title={name}
          position={position}
          showIcon
        />
      )}
    </>
  );
};

Bubble.displayName = "Bubble";

export default Bubble;
